
import { ParallaxEffect, ParallaxContext } from '@/render/parallax/ParallaxEffect';
import { BaseParallaxEffect } from '@/render/parallax/BaseParallaxEffect';

export class BlackHoleSingularityEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;
        const centerR = 80 * scale;

        ctx.strokeStyle = pc.color;

        const draw = () => {
             // Photon sphere
             ctx.save();
             ctx.lineWidth = 4 * scale;
             ctx.globalAlpha *= 0.5;
             ctx.beginPath();
             ctx.arc(0, 0, centerR * 1.5, 0, Math.PI * 2);
             ctx.stroke();
             ctx.restore();

             // Swirling data/matter
             const count = Math.floor(100 * (config.parallaxComplexity || 1.0));
             for (let i = 0; i < count; i++) {
                 const life = (curTime * 0.5 + this.pseudoRandom(i)) % 1;
                 const angle = this.pseudoRandom(i) * Math.PI * 2 + curTime * (1 + life);
                 const r = (300 * scale) * (1 - life) + centerR;
                 
                 const px = Math.cos(angle) * r;
                 const py = Math.sin(angle) * r;
                 
                 ctx.save();
                 ctx.globalAlpha = (1 - life) / (layerIndex + 1);
                 ctx.fillStyle = pc.color;
                 ctx.beginPath();
                 ctx.arc(px, py, 2 * scale, 0, Math.PI * 2);
                 ctx.fill();
                 ctx.restore();
             }
             
             // The Void (black core)
             ctx.fillStyle = "#000000";
             ctx.beginPath();
             ctx.arc(0, 0, centerR, 0, Math.PI * 2);
             ctx.fill();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
